import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

export const ARROW_DIRECTIONS = {
  left: 'left',
  right: 'right',
  bottom: 'bottom',
  top: 'top',
};

interface IArrowDirectionsIconProps {
  direction: string;
}

const useArrowDirectionsIcon = makeStyles({
  left: {
    transform: 'rotate(180deg)',
  },
  right: {
    transform: 'none',
  },
  top: {
    transform: 'rotate(-90deg)',
  },
  bottom: {
    transform: 'rotate(90deg)',
  },
});

const ArrowDirectionsIcon = ({ direction = 'right' }: IArrowDirectionsIconProps) => {
  const classes: any = useArrowDirectionsIcon();
  const directionClass = classes[direction] ? classes[direction] : classes.left;

  return (
    <svg
      className={directionClass}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.4509 0L4.32064 1.11082L8.92184 5.64076H0V7.21639H8.93788L4.33667 11.7463L5.46693 12.8571L12 6.43645L5.4509 0Z"
        fill="#00AEEF"
      />
    </svg>
  );
};

export default ArrowDirectionsIcon;
